// src/pages/TermsOfService.jsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from '../components/Footer';
import Chatbot from '../components/Chatbot';
import '../styles/LegalPage.css';

export default function TermsOfService() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />

      <div className="legal-container">
        <div className="legal-box">
          <h1>{t('terms_title')}</h1>
          <p>{t('terms_intro')}</p>

          <section>
            <h2>{t('terms_section1_title')}</h2>
            <p>{t('terms_section1_content')}</p>
          </section>

          <section>
            <h2>{t('terms_section2_title')}</h2>
            <p>{t('terms_section2_content')}</p>
          </section>

          <section>
            <h2>{t('terms_section3_title')}</h2>
            <p>{t('terms_section3_content')}</p>
          </section>

          <section>
            <h2>{t('terms_section4_title')}</h2>
            <p>{t('terms_section4_content')}</p>
          </section>

          <section>
            <h2>{t('terms_section5_title')}</h2>
            <p>{t('terms_section5_content')}</p>
          </section>

          <section>
            <h2>{t('terms_section6_title')}</h2>
            <p>{t('terms_section6_content')}</p>
          </section>

          <section>
            <h2>{t('terms_section7_title')}</h2>
            <p>
              {t('terms_section7_content')} <a href="mailto:support@healthaiapp.com">support@healthaiapp.com</a>
            </p>
          </section>

          <footer className="legal-footer">
            <p>&copy; {new Date().getFullYear()} HW AI. {t('legal_footer')}</p>
          </footer>
        </div>
      </div>

      <Footer />
      <Chatbot />
    </>
  );
}